import { render } from "./kalio-search-bar.vue?vue&type=template&id=37bb0e41"
import script from "./kalio-search-bar.vue?vue&type=script&lang=js"
export * from "./kalio-search-bar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__